module.exports = __webpack_public_path__ + "img/Feature-1.328549d.svg";